// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
// eslint-disable-next-line import/prefer-default-export
export const env = 'three';
